export enum LinkFilterTypes {
  AllLinks = 'ALL',
  AdLinks = 'AD_LINK',
  QuickLinks = 'QUICK_LINK',
}
